module.exports = __webpack_public_path__ + "img/javid.479f6cf.png";